// Accounts
export const REQUEST_ACCOUNTS = '@main/REQUEST_ACCOUNTS';
export const SET_LIST_ACCOUNTS = '@main/SET_LIST_ACCOUNTS';
export const FETCH_LIST_ACCOUNTS = '@main/FETCH_LIST_ACCOUNTS';
